import R from 'app/assets/R'
import { BaseModalComponent } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { BORDER_RADIUS } from 'parkway-web-common'
import { useTranslation } from 'react-i18next'
import { FormAccountCommon } from '../hook'
import { useHook } from './hook'

export const CreateModalLayout = () => {
  const { t } = useTranslation()
  const { form, modalRef, handleSubmit, isLoading } = useHook()
  return (
    <BaseModalComponent
      titleModal={t(R.strings.create_account)}
      titleOpenModal={t(R.strings.create_account)}
      ref={modalRef}
      handleSubmit={form?.submit}
      borderRadiusButtonOpen={BORDER_RADIUS}
      borderButtonOpen={`1px solid ${convertedVariables.neutralBlack9Color}`}
      styleButtonOpen={{
        backgroundColor: convertedVariables?.backgroundColor,
      }}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm
          form={form}
          onFinish={handleSubmit}
          initialValues={{
            isActive: true,
          }}
        >
          <FormAccountCommon form={form} />
        </BaseForm>
      }
    />
  )
}
